import { Time } from 'lightweight-charts'
import { ChartCandle } from '../chartV2/chart.typings';

export function getCumLineData(seriesData: ChartCandle[][]): Partial<ChartCandle>[] {
    const allTimes = new Set<Time>();
    seriesData.forEach(series => {
        series.forEach(point => allTimes.add(point.time));
    });

    const sortedTimes = Array.from(allTimes).sort();
    const seriesMaps = seriesData.map(series => {
        const map = new Map<Time, number>();
        series.forEach(point => {
            map.set(point.time, point.openInterest);
        });
        return map;
    });

    const previousValues = Array(seriesData.length).fill(0);
    const summedSeries: Partial<ChartCandle>[] = [];

    sortedTimes.forEach((time, i) => {
        let sum = 0;
        seriesMaps.forEach((seriesMap, index) => {
            if (seriesMap.has(time)) {
                previousValues[index] = seriesMap.get(time)!;
            }
            sum += previousValues[index];
        });
        summedSeries.push({
            time,
            openInterest: sum,
            series: i===0 ? 0 : sum - (summedSeries[summedSeries.length-1].openInterest??sum),
        });
    });

    return summedSeries;
}

export function updateCumLineData(existingData: Partial<ChartCandle>[], seriesData: ChartCandle[][]): Partial<ChartCandle>[][] {
    if(!existingData || existingData.length === 0) {
        return [getCumLineData(seriesData), []]
    }
    let lastExistingTime = existingData[existingData.length-1].time
    if(!lastExistingTime) return [existingData, []]
    const newSeriesData: ChartCandle[][] = []
    seriesData.forEach((series)=>{
        let startIndex = series.length - 1
        while(startIndex>0 && series[startIndex].time>(lastExistingTime??0)) {
            startIndex--
        }
        startIndex = Math.max(0, startIndex-3)
        newSeriesData.push(series.slice(startIndex+1))
    })
    const prevData = [...existingData]
    prevData.pop()
    lastExistingTime = prevData[prevData.length-1].time
    let nextData = getCumLineData(newSeriesData)
    let i = 0
    while(i<nextData.length && nextData[i].time && (nextData[i]?.time??0)<=(lastExistingTime??0)) {
        i++
    }
    nextData = nextData.slice(i)

    return [[...prevData, ...nextData], nextData]
}